import { render } from "./CreateGoalByLib_Goals.vue?vue&type=template&id=0dfad262&scoped=true"
import script from "./CreateGoalByLib_Goals.vue?vue&type=script&lang=js"
export * from "./CreateGoalByLib_Goals.vue?vue&type=script&lang=js"

import "./CreateGoalByLib_Goals.vue?vue&type=style&index=0&id=0dfad262&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dfad262"]])

export default __exports__